export enum ErrorToastWishList {
  ADDING_PRODUCT_TO_WISH_LIST='error.adding.product.to.wishlist',
  CREATING_WISH_LIST='error.creating.wishlist',
  CREATING_WISH_LIST_LIMIT_EXCEEDED='error.creating.wishlist.limit.exceeded',
  DELETING_WISH_LIST='error.deleting.wishlist',
  FETCHING_WISH_LISTS='error.fetching.wishLists',
  FETCHING_WISH_LIST_ITEMS='error.fetching.wishList.items',
  REMOVING_PRODUCT_FROM_WISH_LIST='error.removing.product.from.wishlist',
  UPDATING_WISH_LIST='error.updating.wishlist',
  UPDATING_WISH_LIST_COMMENT='error.updating.wishlist.comment',
  BULK_ADD_TO_CART='error.bulk.add.to.cart',
}
